import { Box } from '@factorialco/deprecated-design-system'
import { ProductUpdatesUpdate } from 'generated/resources/graphql'
import moment from 'moment'

import Buttons from '../../Buttons'
import Media from './_Media'

type TextSectionProps = {
  title: string
  description: string
  productUpdateSlug: string
}

const TextSection = ({ title, description }: TextSectionProps) => {
  return (
    <Box gap="s12">
      <span className="text-lg font-semibold">{title}</span>
      <span className="text-lg text-f1-foreground-secondary">{description}</span>
    </Box>
  )
}

const Card = ({
  id,
  title,
  shortDescription,
  thumbnail,
  slug,
  media,
  chargebeeModuleName,
  featureRelated,
  releaseDate,
}: ProductUpdatesUpdate) => {
  const featureIdentifier = featureRelated?.featureIdentifier || ''
  const today = moment().startOf('day')

  const isAlreadyReleased = today.isSameOrAfter(releaseDate)

  return (
    <Box
      className="card"
      flexDirection="column"
      gap="s16"
      paddingY="s16"
      style={{ maxWidth: '480px', display: 'flex', height: '100%' }} // Ensures all cards match the tallest one
    >
      <Box className="aspect-video">
        <Media id={id} media={media} thumbnail={thumbnail} slug={slug} autoplay />
      </Box>

      <Box flexDirection="column" gap="s16" style={{ flexGrow: '1' }}>
        <TextSection title={title} description={shortDescription} productUpdateSlug={slug} />
      </Box>

      <Box style={{ alignSelf: 'stretch', width: 'fit-content' }}>
        <Buttons
          chargebeeModuleName={chargebeeModuleName || ''}
          productUpdateSlug={slug}
          isAlreadyReleased={isAlreadyReleased}
          featureIdentifier={featureIdentifier}
          productUpdateId={id}
          version="factorial-one"
          source="updates-with-ceo"
        />
      </Box>
    </Box>
  )
}

export default Card
